export function getTimeoutFromStorage(resendTimeoutStorageKey: string) {
    const value = localStorage.getItem(resendTimeoutStorageKey);

    if (!value) {
        return null;
    }

    const numValue = Number(value);

    if (Number.isSafeInteger(numValue)) {
        return numValue;
    }

    return null;
}

export function setTimeoutToStorage(resendTimeoutStorageKey: string, timeout: number) {
    try {
        localStorage.setItem(resendTimeoutStorageKey, String(timeout));
    } catch (error) {
        console.error(error);
    }
}

export function removeTimeoutFromStorage(resendTimeoutStorageKey: string) {
    localStorage.removeItem(resendTimeoutStorageKey);
}
